export const PATHS = {
  HOME: '/',

  PROFILE: '/profile',

  SCHEDULING: '/scheduling',

  DOCUMENTATION: '/documentation',

  // Children (relative)
  PASSPORT: 'passport',
  VISA: 'visa',
  PICKUP: 'pickup',
  WORK_PERMIT: 'work-permit',
  MEDICAL_CERTIFICATE: 'medical-certificate',
} as const;

export const ABS_PATHS = {
  PASSPORT: `${PATHS.DOCUMENTATION}/${PATHS.PASSPORT}`,
  VISA: `${PATHS.DOCUMENTATION}/${PATHS.VISA}`,
  PICKUP: `${PATHS.DOCUMENTATION}/${PATHS.PICKUP}`,
  WORK_PERMIT: `${PATHS.DOCUMENTATION}/${PATHS.WORK_PERMIT}`,
  MEDICAL_CERTIFICATE: `${PATHS.DOCUMENTATION}/${PATHS.MEDICAL_CERTIFICATE}`,
} as const;
